// l10n status: n/a
import React, { useEffect, useState, useRef } from "react"
import { observer } from "mobx-react"
import { appFeatures } from "AppFeatures"
import { rootStore } from "store/RootStore"
import { Button } from "@mui/material"
import { useMediaQuery } from "hooks/useMediaQyery"
import { Outlet } from "react-router"
import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"
import { l10n } from "store/lang/L10n"
import { isIpad, isPhoneSize, isIphone, isAndroid } from "utils/Utils"
import * as zingengine from "zingengine"
// shaka!

let canvasSnapshot = null
let savedCanvas = null

export const PersistentCanvas = () => {
	const canvasRef = useRef(null)
	const updateTimerId = useRef(null)
	const currentScreen = useRef(null)

	let radioShown = true
	function toggleRadio() {
		if (typeof window.zingApp === "undefined")
			 return

		if (radioShown) {
			 radioShown = false
			 window.zingApp.call("hideRadio")
		} else {
			 radioShown = true
			 window.zingApp.call("showRadio")
		}
  }

	const isMobile = useMediaQuery('(max-width: 540px)')
	const isMedium = useMediaQuery('(max-width: 1024px)')

  	// channels are copied in zing, so we don't need to keep them when coming back to the radio tab
	const [channels, setChannels] = useState(null)

	function storeRecentChannels(channels) {
		const channelIds = []
		channels?.forEach(channel => {
			channelIds.push(channel.id)
		})
		//console.debug("storeRecentChannels channelIds:", channelIds)
		rootStore.sso.browserStore.setRadioChannels(channelIds)
	}

	function analytics(data) {
		console.debug("analytics message", data)
		const screens = {
			recent: analyticsScreen.radioRecent,
			genres: analyticsScreen.radioGenres,
			languages: analyticsScreen.radioLanguages,
			search: analyticsScreen.radioSearch,
		}

		switch (data?.eventName) {
			case "zingRadioVolumeChanged":
				if (data.data !== "%") {
					const volume = Number(data.data.replace("%", ""))
					//console.debug("message volume", volume)
					if (updateTimerId.current) clearTimeout(updateTimerId.current)
					updateTimerId.current = setTimeout(() => {
						rootStore.sso.browserStore.setVolume(volume)
						rootStore.page.Player.settings.volume = volume
						//rootStore.page.Player.settings.isMuted = rootStore.sso.browserStore.getMuted()
					}, 200)
				}
				break
			case "zingRadioMuted":
				rootStore.sso.browserStore.setMuted(true)
				rootStore.page.Player.settings.isMuted = true
				break
			case "zingRadioUnmuted":
				rootStore.sso.browserStore.setMuted(false)
				rootStore.page.Player.settings.isMuted = false
				break
			case "zingRadioPlayStation":
			case "zingRadioResumeStation":
				//console.debug("zingRadioPlayStation:", data?.data?.name, currentScreen.current)
				rootStore.logService.analyticsRadioStart({[analyticsMeta.radioOrigin]: currentScreen.current, [analyticsMeta.radioStation]: data?.data?.name})
				break
			case "zingRadioSelectedCategory":
				const screenView = screens[data?.data]
				//console.debug("zingRadioSelectedScreen:", screenView)
				if (screenView) {
					currentScreen.current = screenView
					rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: screenView })
				}
				break
			case "zingRadioSearchOpened":
				const screenSearch = screens["search"]
				//console.debug("zingRadioSelectedScreen:", screenSearch)
				if (screenSearch) {
					currentScreen.current = screenSearch
					rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: screenSearch })
				}
				break
			default:
				break
		}
	}

	function getRecentChannels(data = null) {
		const radioChannels = data ?? channels
		const recentChannels = rootStore.sso.browserStore.getRadioChannels()
		const fullChannelInfo = []
		recentChannels?.forEach(channel => {
			const found = radioChannels?.channels.find((element) => element.id === channel)
			fullChannelInfo.push(found)
		})
		return fullChannelInfo
	}

	function messageHandler(message) {
		//console.debug("zing message", message?.data?.action, message?.data)
		switch (message?.data?.action) {
			case "storeRecentChannels":
				//console.debug("recentChannels message", message)
				storeRecentChannels(message?.data?.channels)
				break
			case "sendAnalyticsEvent":
				analytics(message?.data)
				break
			default:
				break
		}
	}

	function buildProxyUrl(targetUrl, headerRewrites = {}) {
		const encodedUrl = encodeURIComponent(targetUrl)
		let proxyUrl = `https://corsproxy.io/?key=468dec80&url=${encodedUrl}`
		
		// Add header rewrites
		Object.entries(headerRewrites).forEach(([header, value]) => {
			const headerParam = value === null || value === '' 
				? `${header}:` // Remove header
				: `${header}:${value}`
			proxyUrl += `&headers[]=${encodeURIComponent(headerParam)}`
		})
		
		return proxyUrl
	}

	function test1() {
		const corsHeaders = {
			'access-control-allow-origin': 'https://content.quickline.ch',
			'access-control-allow-methods': 'HEAD, GET, POST, PUT, DELETE',
			//'access-control-allow-headers': 'Content-Type, Authorization',
			//'x-xss-protection': '0',
		}
		const url = buildProxyUrl("http://stream.srg-ssr.ch/m/drs1/mp3_128", corsHeaders)
		console.debug("test2", url)
		fetch(url, //&headers[]=X-XSS-Protection%30", //&headers[]=credentials%3Aomit&headers[]=Connection:keep-alive",
			{
				method: 'HEAD',
				headers: {
					'credentials': 'omit',
					//'Accept': 'audio/mpeg',
					//'Connection': 'keep-alive',
					//'Proxy-Connection': 'keep-alive',
					//'upgrade-insecure-requests': '0',
				 },
			}
		 )
		 .then((resp) => {
			//fetch("https://corsproxy.io/?key=468dec80&url=https%3A%2F%2Fstream.streambase.ch%2Fcrock%2Fmp3-192%2Fquickline%2F&headers[]=credentials%3Aomit",
			fetch(url, //&headers[]=X-XSS-Protection%30", //&headers[]=credentials%3Aomit&headers[]=Connection:keep-alive",
				{
					method: 'GET',
					headers: {
						'credentials': 'omit',
						//'Accept': 'audio/mpeg',
						//'connection': 'keep-alive',
						//'proxy-connection': 'keep-alive',
						//'upgrade-insecure-requests': '0',
					 },
				},
			 )
			 .then((response) => {
				console.debug("blobUrl", response)
				response.blob()
			 })
			 .then(blob => {
				 //debugger
				 const url = URL.createObjectURL(blob)
				 console.debug("blobUrl", url, blob)
				 const video = document.createElement('audio')
				 video.src = url
				 video.controls = true
				 document.body.appendChild(video)
			 })
		 })
	}

	function test2() {
		const corsHeaders = {
			'access-control-allow-origin': 'https://content.quickline.ch',
			'access-control-allow-methods': 'HEAD, GET, POST, PUT, DELETE',
			//'access-control-allow-headers': 'Content-Type, Authorization',
			//'x-xss-protection': '0',
		}
		const url = buildProxyUrl("https://livestreaming-node-1.srg-ssr.ch/srgssr/srf1/mp3/128", corsHeaders)
		console.debug("test2", url)
		fetch(url, //&headers[]=X-XSS-Protection%30", //&headers[]=credentials%3Aomit&headers[]=Connection:keep-alive",
			{
				method: 'HEAD',
				headers: {
					'credentials': 'omit',
					//'Accept': 'audio/mpeg',
					//'Connection': 'keep-alive',
					//'Proxy-Connection': 'keep-alive',
					//'upgrade-insecure-requests': '0',
				 },
			}
		 )
		 .then((resp) => {
			//fetch("https://corsproxy.io/?key=468dec80&url=https%3A%2F%2Fstream.streambase.ch%2Fcrock%2Fmp3-192%2Fquickline%2F&headers[]=credentials%3Aomit",
			fetch(url, //&headers[]=X-XSS-Protection%30", //&headers[]=credentials%3Aomit&headers[]=Connection:keep-alive",
				{
					method: 'GET',
					headers: {
						'credentials': 'omit',
						//'Accept': 'audio/mpeg',
						//'connection': 'keep-alive',
						//'proxy-connection': 'keep-alive',
						//'upgrade-insecure-requests': '0',
					 },
				},
			 )
			 .then((response) => {
				console.debug("blobUrl", response)
				response.blob()
			 })
			 .then(blob => {
				 //debugger
				 const url = URL.createObjectURL(blob)
				 console.debug("blobUrl", url, blob)
				 const video = document.createElement('audio')
				 video.src = url
				 video.controls = true
				 document.body.appendChild(video)
			 })
		 })
	}

	function test3() {
		console.debug("test3")
		try {
			let url = "https://stream.srg-ssr.ch/m/drs1/mp3_128"
			url = "https://energymetime.ice.infomaniak.ch/energymetime-high.mp3"
			//url = "https://stream.streambase.ch/crock/mp3-192/quickline/"
			const target = encodeURIComponent(url)
			//const audio = new Audio("https://livestreaming-node-1.srg-ssr.ch/srgssr/srf1/mp3/128")
			//const audio = new Audio("http://stream.srg-ssr.ch/m/drs1/mp3_128")
			//const audio = new Audio(`https://api.cors.lol/?url=${target}&token=Ctln384fGdUX39Ld`)
			const audio = new Audio(target)
			audio.play()
		}
		catch (e) {
			console.error("test3", e)
		}
	}

	function testSnippets() {

		//fetch("https://go.x2u.in/proxy?email=ivo.hirt@qlgroup.ch&apiKey=78c95713&url=https://livestreaming-node-1.srg-ssr.ch/srgssr/srf1/mp3/128")

		
		console.debug("Livestreaming-node-1", encodeURIComponent("https://livestreaming-node-1.srg-ssr.ch/srgssr/srf1/mp3/128"))
		/* corsproxy trial */ //https://corsproxy.io/?key=abcd1234&
		/*
		fetch('https://video.corsproxy.io/?key=468dec80&url=https%3A%2F%2Fstream.streambase.ch%2Fcrock%2Fmp3-192%2Fquickline%2F&headers[]=credentials%3Aomit')
			//.then(response => response.blob())
			.then((response) => {
				debugger
			})
			.then(blob => {
				const url = URL.createObjectURL(blob)
				const video = document.createElement('video')
				video.src = url
				video.controls = true
				document.body.appendChild(video)
			})
		*/
		/**/
		/**/
		//GET /79-classicrock-mp3-192-6577748?sABC=693n1r6p%230%238p52s02o840o4onrs3qn4sop2q077qqp%23dhvpxyvar&aw_0_1st.playerid=quickline&amsparams=playerid:quickline;skey:1765416556 HTTP/1.1
		//fetch("https://corsproxy.io/?key=468dec80&url=https%3A%2F%2Fstream.streambase.ch%2Fcrock%2Fmp3-192%2Fquickline%2F&headers[]=credentials%3Aomit",
		/*
		fetch("https://corsproxy.io/?key=468dec80&url=https%3A%2F%2Flivestreaming-node-1.srg-ssr.ch%2Fsrgssr%2Fsrf1%2Fmp3%2F128", //&headers[]=X-XSS-Protection%30", //&headers[]=credentials%3Aomit&headers[]=Connection:keep-alive",
			{
				method: 'GET',
			},
		 )
		 */
	

		/* corsfix trial*/
		/*
		fetch("https://api.cors.lol/?url=https://stream.streambase.ch/crock/mp3-192/quickline/")	
			.then((res) => {
				console.debug("corsfix", res)
			}).catch((e) => {
				console.error("corsfix", e)
			})
		*/
		/*
		fetch("https://proxy-eu.corsfix.com/?url=https://stream.streambase.ch/crock/mp3-192/", {	
			headers: {
				"x-corsfix-headers": JSON.stringify({
					Origin: "https://content.quickline.ch",
					Referer: "https://content.quickline.ch",
					"Access-Control-Request-Method": "*"
				}),
			},
			}).then((res) => {
				console.debug("corsfix", res)
			}).catch((e) => {
				console.error("corsfix", e)
			})
		*/

		/*
		const ctx = canvas.getContext("2d")
		ctx.fillStyle = "blue"
		ctx.fillRect(10, 10, 100, 100)
		*/
		/*
		fetch("https://poster-api.quickline.ch/PosterISEPG/Radio_Logos_v2/6038_SRF_4_News.png").then((res) => {
			console.debug("radio poster", res)
		})
		*/
	}

	/* crossOrigin is now not set anymore in zingengine, so this patch is not needed
	// PATCH, disable setting of crossOrigin
	function interceptCrossOrigin(el) {
		let _crossOrigin = el.crossOrigin

		Object.defineProperty(el, 'crossOrigin', {
			get() {
				return _crossOrigin
			},
			set(value) {
				// Block, leave as is
				//_crossOrigin = value === 'anonymous' ? value : 'anonymous'
			},
			configurable: true,
			enumerable: true
		})
	}
	// PATCH, disable setting of crossOrigin
	document.createElement = function(create) {
		return function() {
			var ret = create.apply(this, arguments)
			if (ret.tagName.toLowerCase() === "video") {
				//ret.volume = 0.5
				interceptCrossOrigin(ret)
			}
			return ret
		}
	}(document.createElement)
	*/
  
	const [zingApp, setZingApp] = useState(window.zingApp ?? null)

	/*
	useEffect(() => {
		if (window.zingApp) {
			setZingApp(window.zingApp)
			return
		}

		const interval = setInterval(() => {
			if (window.zingApp) {
				setZingApp(window.zingApp)
				clearInterval(interval)
			}
		}, 100)

		return () => clearInterval(interval)
	}, [])
	*/

	/*
	rootStore.channelsService.getRadioChannelsAsync().then((json) => {
		let channels = null
		if (typeof json === "string") channels = JSON.parse(json)
		// corsfix trial, exclude hls
		for (let i = 0; i < channels?.channels.length; i++) {
			console.debug("radio", i, channels.channels[i].name, channels.channels[i].streamUri)
			channels.channels[i].streamUri = channels.channels[i].streamUri.replace("http://", "https://")
			//channels.channels[i].streamUri = encodeURIComponent(channels.channels[i].streamUri.replace("http://", "https://"))
			if (channels.channels[i].streamUri.indexOf(".m3u8") <= 0) {
				const url = channels.channels[i].streamUri//.replace("quickline/", "")
				//console.debug("streamUrl", channels.channels[i].name, url)
				//const target = url
				const target = encodeURIComponent(url)
				//channels.channels[i].streamUri = target
				//channels.channels[i].streamUri = `https://api.cors.lol/?url=${target}&token=Ctln384fGdUX39Ld`

				// Add CORS headers to non-CORS API
				const corsHeaders = {
					'credentials': 'omit',
					'access-control-allow-origin': 'https://content.quickline.ch',
					'access-control-allow-methods': 'HEAD, GET, POST, PUT, DELETE',
					'access-control-allow-headers': 'Content-Type, Authorization',
					'x-xss-protection': '0',
				}
				//channels.channels[i].streamUri = buildProxyUrl(url, corsHeaders)
			}
		}
		//console.debug("radioChannels", channels)
		const corsHeaders = {
			'credentials': 'omit',
			'access-control-allow-origin': 'https://content.quickline.ch',
			'access-control-allow-methods': 'HEAD, GET, POST, PUT, DELETE',
			'access-control-allow-headers': 'Content-Type, Authorization',
			'x-xss-protection': '0',
		}
		for (let i = 0; i < channels?.channels.length; i++) {
			//const target = encodeURIComponent(channels.channels[i].streamUri)
			//channels.channels[i].streamUri = buildProxyUrl(channels.channels[i].streamUri, corsHeaders)
			//channels.channels[i].streamUri = `https://api.cors.lol/?url=${target}&token=Ctln384fGdUX39Ld`
		}

		if (channels) {
			setChannels(channels)
		}
	})
	*/

	function setup(zing, data, recentChannels) {
		//debugger
		zing.call("loadChannels", data, recentChannels)
		const volume = rootStore.sso.browserStore.getVolume()
		const isMuted = rootStore.sso.browserStore.getMuted()
		const showSlider = !(isPhoneSize() || isIpad())
		console.debug("calling setAppVolume", volume/100, isMuted, showSlider)
		zing.call("setAppVolume", volume/100, isMuted, showSlider)
		const locale = appFeatures.locale
		console.debug("calling setAppLanguage", locale, l10n)
		zing.call("setAppLanguage", locale, l10n)
	}

	useEffect(() => {	
		const handler = () => setZingApp(window.zingApp)

		rootStore.channelsService.getRadioChannelsAsync().then((json) => {
			let data = typeof json === "string" ? JSON.parse(json) : json
	  
			data?.channels?.forEach((ch) => {
			  ch.streamUri = ch.streamUri.replace("http://", "https://");
			  //console.debug("zingRadio channel", ch, ch.name, ch.streamUri)
			})
	  
			setChannels(data)
			if (window.zingApp) {
				const recentChannels = getRecentChannels(data)
				console.debug("useeffect set recentChannels", recentChannels, window.zingApp)
				setup(window.zingApp, data, recentChannels)
			}
			console.debug("zingApp useEffect")
		 })
	 
		window.addEventListener("zingAppReady", handler)
		console.debug("zingRadio useEffect", window.zingApp)
		/*
		if (window.zingApp) {
			console.debug("zingRadio showRadio")
			window.zingApp.call("showRadio")
		}
		*/
		currentScreen.current = analyticsScreen.radio	
		rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.radio })

		return () => {
			console.debug("zingRadio ~useEffect", window.zingApp)
			/*
			if (window.zingApp) {
				console.debug("zingRadio hideRadio")
				window.zingApp.call("hideRadio")
			}
			*/
			window.removeEventListener("zingAppReady", handler)
		}
	}, [])

	useEffect(() => {
		const canvas = canvasRef.current
		if (!canvas || !zingApp) return
	 
		const focus = () => canvas.focus()
		canvas.tabIndex = 1
		canvas.style.outline = "none"
		canvas.addEventListener("pointerdown", focus)

		console.debug("zingRadio showRadio", canvas)
		zingApp.call("showRadio")
	 
		return () => {
		  console.debug("zingRadio hideRadio")
		  zingApp.call("hideRadio")
		  canvas.removeEventListener("pointerdown", focus)
		}
	 }, [zingApp])

	useEffect(() => {
		if (savedCanvas) {
			// hack for strange unmount/remounted canvas when reloading from radio page
			document.body.appendChild(savedCanvas)
			console.debug("zingRadio canvas reattached", savedCanvas)
			savedCanvas = null
		}

		const canvas = document.getElementById('radioCanvas')
		canvas.addEventListener("pointerdown", () => { canvas?.focus() })
		console.debug("zingRadio canvas", canvas, rootStore.sso.baseUrl().replace("/#/", "") + "/zingradio.bin", channels)
		/*
		fetch(rootStore.sso.baseUrl().replace("/#/", "") + "/zingradio.bin").then((resp) => {
			console.debug("radio got", resp)
			resp.arrayBuffer().then((buffer) => {
				console.debug("radio buffer", buffer)
				//zingengine.initialize(canvas, {application: buffer}).then((res) => {})
				//.catch((e) => {console.error("zingengine.initialize", e)})
			})
		})
		*/

		const recentChannels = channels ? getRecentChannels() : []
		//console.debug("recentChannels=", recentChannels, channels, window.zingApp)
		if (channels && !window.zingApp) {
			if (window.__wasm_initialized__) {
				console.warn("⚠️ zingRadio WASM already initialized, skipping")
				return
			}
			window.__wasm_initialized__ = true

			zingengine.addEventListener("broadcastmessage", messageHandler)
			zingengine.initialize(canvas, {application: rootStore.sso.baseUrl().replace("/#/", "") + "/zingradio.bin"/*, mode: "st"*/})
				.then((zingAppl) => {
					window.zingApp = zingAppl
					window.dispatchEvent(new Event("zingAppReady"))
					setZingApp(zingAppl)
					setup(zingAppl, channels, recentChannels)
					if (window.location.href.indexOf("radio") > 0) {
						// hack for strange unmount/remounted canvas when reloading from radio page
						savedCanvas = canvas
					}
			
					console.debug("✅ zingRadio ZingEngine ready", channels)
				})
				.catch((e) => {console.error("zingRadio zingengine.initialize", e)})
		}
		else if (window.zingApp) {
			if (channels) {
				setup(window.zingApp, channels, recentChannels)
			}
			// transition to hide followed by show to avoid recent channels update issue on profile change
			window.zingApp.call("hideRadio")
			setTimeout(() => {
				window.zingApp.call("showRadio")
			}, 150)
		}
	}, [channels])

	// navbarContainer heigth: 60 / 90 /56
	
	return (
		<>
		<canvas
			ref={canvasRef}
			id="radioCanvas"
			tabIndex={1}
			style={{
				touchAction: "none",
				outline: "none",
				pointerEvents: "auto",
				position: "fixed",
				//zIndex: 1,
				width: "100%",
				height: isMobile
					? "calc(100vh - 152px)"
					: isMedium
					? "calc(100vh - 90px)"
					: "calc(100vh - 60px)"
			}}
		/>
			{/*
			<div id="button_container">
			<Button id="button" style={{top: 16, left: 16}} onClick={toggleRadio}>Toggle Radio</Button>
			</div>
			*/}
		</>
	)
 }

export const Radio = () => {

	return (
		<>
		  {appFeatures.radioEnabled && <PersistentCanvas />}
		  <Outlet /> {/* route changes below won’t affect the canvas */}
		</>
	)
	//return <Outlet />  // The persistent canvas lives globally
}
